import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/types';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  const categoryNames: Record<string, string> = {
    romance: '恋爱',
    fantasy: '奇幻',
    action: '动作',
    thriller: '悬疑',
    'slice-of-life': '日常',
    comedy: '搞笑',
    drama: '剧情',
    completed: '完结',
  };

  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block bg-background-50 rounded-lg border border-background-200 hover:border-primary-300 transition-all duration-300 overflow-hidden"
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-background-100">
        <div className="absolute inset-0 flex items-center justify-center text-foreground-300">
          <i className="ri-image-line text-4xl"></i>
        </div>
        <div className="absolute top-2 left-2 z-10 flex flex-col gap-1">
          {comic.status === '已完结' && (
            <span className="px-2 py-0.5 rounded text-[10px] font-semibold bg-secondary-500 text-background-50 whitespace-nowrap">
              {comic.status}
            </span>
          )}
          {comic.status === '连载中' && (
            <span className="px-2 py-0.5 rounded text-[10px] font-semibold bg-accent-500 text-background-50 whitespace-nowrap">
              {comic.status}
            </span>
          )}
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3 pt-8">
          <div className="flex items-center gap-1 text-background-50 text-xs">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            <span className="font-semibold">{comic.rating}</span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">
          {comic.author} · {categoryNames[comic.category] || comic.category}
        </p>
        <div className="flex items-center justify-between mt-2">
          <span className="text-xs text-foreground-400">
            共{comic.chapters}话
          </span>
          <span className="text-xs text-foreground-400">
            {comic.updateDate}
          </span>
        </div>
      </div>
    </Link>
  );
}